import React, { useRef, useContext, useState } from "react";
import * as S from "./styles";
import logoSin from "../../assets/ATUAL APP - SIN_Sinosserra-branco.svg";
import history from "../../utils/history";
import { mask, unMask } from "../../utils/mask";
import { toast } from "react-toastify";

import authService from "../../services/AuthService";

import Button from "../../components/Button";
import BorderedInputText from "../../components/BorderedInputText";
import { Context } from "../../context/globalContext";
import { Authenticate, dataForm } from "../../hooks/authenticate";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import Skeleton from "../../components/skeleton";

const SignupSchema = Yup.object().shape({
  username: Yup.string()
    .matches(/[0-9]{3}.?[0-9]{3}.?[0-9]{3}-?[0-9]{2}/, "declined")
    .required("Required"),
  password: Yup.string().required("Required"),
});

export default function Login() {
  const { setIsLoading, HandleLogin, HandleLogout } = useContext(Context);
  const globalContext = useContext(Context);

  const verifyUserAccess = async (ev, unmaskedValues) => {
    try {
      await HandleLogin(ev.data, unmaskedValues.username);
      const response = await authService.getUser();
      if (response && response.status === 200) {
        localStorage.setItem("loggedUser", JSON.stringify(response.data));
        history.push("/home");
        setIsLoading(false);
        return;
      }

      HandleLogout(ev.data);
      toast.error("Você não possui acesso a este sistema.");
      setIsLoading(false);
    } catch (e) {
      toast.error("Você não possui acesso a este sistema.");
      setIsLoading(false);
    }
  };

  const HandleSubmit = (values) => {
    const unmaskedValues = {
      ...values,
      username: unMask(values.username, "\\.|-"),
    };

    setIsLoading(true);
    Authenticate.SignInRequest(unmaskedValues)
      .then((ev) => {
        verifyUserAccess(ev, unmaskedValues);
      })
      .catch((ev) => {
        toast.error("Login ou Senha incorretos");
        HandleLogout(ev.data);
        setIsLoading(false);
      });
  };

  return (
    <S.Wrapper>
      <S.LeftWrapper>
        <div />
        <img src={logoSin} />
      </S.LeftWrapper>

      <S.RightWrapper>
        <div>
          <S.Header>
            <S.TitleBox>
              <div>
                <S.Title>Bem vindo ao</S.Title>
                <S.Description>Sistema de retaguarda Sinosserra!</S.Description>
              </div>
            </S.TitleBox>
          </S.Header>

          <S.Content>
            <Formik
              initialValues={{ username: "", password: "" }}
              validationSchema={SignupSchema}
              onSubmit={async (values) => HandleSubmit(values)}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form>
                  <div className="div-form">
                    {!globalContext.isLoading ? (
                      <BorderedInputText
                        name="username"
                        label="CPF do usuário"
                        error={!!errors.username && !!touched.username}
                        valid={
                          !!values.username &&
                          !!touched.username &&
                          !errors.username
                        }
                        value={values.username}
                        onChange={(e) => {
                          setFieldValue(
                            "username",
                            mask(
                              unMask(e.target.value, "\\.|-"),
                              "###.###.###-##",
                              true
                            )
                          );
                        }}
                      />
                    ) : (
                      <S.SkeletonInput>
                        {" "}
                        <Skeleton type="label" />
                        <Skeleton type="borderedInput" />
                      </S.SkeletonInput>
                    )}
                  </div>
                  <div className="div-form">
                    {!globalContext.isLoading ? (
                      <BorderedInputText
                        type="password"
                        name="password"
                        label="Senha da rede"
                        icon="true"
                        visState="false"
                        value={values.password}
                        onChange={(e) => {
                          setFieldValue("password", e.target.value);
                        }}
                      />
                    ) : (
                      <S.SkeletonInput>
                        <Skeleton type="label" />
                        <Skeleton type="borderedInput" />
                      </S.SkeletonInput>
                    )}
                  </div>
                  <S.ButtonContainer>
                    <Button type="submit">Entrar</Button>
                    <S.ForgotPassWord>
                      <a href="/forgot-password">Esqueci minha senha</a>
                    </S.ForgotPassWord>
                  </S.ButtonContainer>
                </Form>
              )}
            </Formik>
          </S.Content>
        </div>
      </S.RightWrapper>
    </S.Wrapper>
  );
}
